import { styled } from '@mui/material/styles';
import { Paper, Container } from '@mui/material';

export const StyledContainer = styled(Container)(({ theme }) => ({
  padding: theme.spacing(3),
}));

export const StyledListContainer = styled(Paper)(({ theme }) => ({
  height: '70vh',
  overflowY: 'auto',
  padding: theme.spacing(2),
}));

export const StyledFormContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
}));

export const StyledViewContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
}));
